'use strict';exports.__esModule = true;exports.updatePropertiesContacts = exports.clearUpdatedState = exports.setCurrentPaginationStep = exports.updatePropertyData = exports.updatePropertyHighlighting = exports.updatePropertyActivity = exports.clearUserPropertiesData = exports.activateTopPromotion = exports.activateAutoJump = exports.secondJumpToTop = exports.movePropertyToTop = exports.editProperty = exports.loadProjectById = exports.loadPropertyById = exports.exportUserProperties = exports.loadUserProperties = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _fileSaver = require('file-saver');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var loadUserProperties = (0, _reduxAct.createAction)('/LOAD_USER_PROPERTY');
var loadUserPropertiesSuccess = (0, _reduxAct.createAction)('/LOAD_USER_PROPERTY_SUCCESS');
var loadUserPropertiesFail = (0, _reduxAct.createAction)('/LOAD_USER_PROPERTY_FAIL');
var exportUserProperties = (0, _reduxAct.createAction)('/EXPORT_USER_PROPERTY');
var exportUserPropertiesSuccess = (0, _reduxAct.createAction)('/EXPORT_USER_PROPERTY_SUCCESS');
var exportUserPropertiesFail = (0, _reduxAct.createAction)('/EXPORT_USER_PROPERTY_FAIL');
var loadPropertyById = (0, _reduxAct.createAction)('/LOAD_PROPERTY_BY_ID');
var loadPropertyByIdSuccess = (0, _reduxAct.createAction)('/LOAD_PROPERTY_BY_ID_SUCCESS');
var loadPropertyByIdFail = (0, _reduxAct.createAction)('/LOAD_PROPERTY_BY_ID_FAIL');

var loadProjectById = (0, _reduxAct.createAction)('/LOAD_PROJECT_BY_ID');
var loadProjectByIdSuccess = (0, _reduxAct.createAction)('/LOAD_PROJECT_BY_ID_SUCCESS');
var loadProjectByIdFail = (0, _reduxAct.createAction)('/LOAD_PROJECT_BY_ID_FAIL');

var editProperty = (0, _reduxAct.createAction)('/EDIT_PROPERTY');
var updatePropertyActivity = (0, _reduxAct.createAction)('/ACTIVATE_PROPERTIES');
var updatePropertyActivitySuccess = (0, _reduxAct.createAction)('/ACTIVATE_PROPERTIES_SUCCESS');
var updatePropertyActivityFail = (0, _reduxAct.createAction)('/ACTIVATE_PROPERTIES_FAIL');
var updatePropertiesContacts = (0, _reduxAct.createAction)('/UPDATE_PROPERTIES_CONTACTS');
var updatePropertiesContactsSuccess = (0, _reduxAct.createAction)('/UPDATE_PROPERTIES_CONTACTS_SUCCESS');
var updatePropertiesContactsFail = (0, _reduxAct.createAction)('/UPDATE_PROPERTIES_CONTACTS_FAIL');
var updatePropertyHighlighting = (0, _reduxAct.createAction)('/HIGHLIGHT_PROPERTIES');
var updatePropertyHighlightingSuccess = (0, _reduxAct.createAction)('/HIGHLIGHT_PROPERTIES_SUCCESS');
var updatePropertyHighlightingFail = (0, _reduxAct.createAction)('/HIGHLIGHT_PROPERTIES_FAIL');
var movePropertyToTop = (0, _reduxAct.createAction)('/MOVE_PROPERTY_TO_TOP');
var secondJumpToTop = (0, _reduxAct.createAction)('/SECOND_JUMP_TO_TOP');
var secondJumpToTopSuccess = (0, _reduxAct.createAction)('/SECOND_JUMP_TO_TOP_SUCCESS');
var secondJumpToTopFail = (0, _reduxAct.createAction)('/SECOND_JUMP_TO_TOP_FAIL');
var movePropertyToTopSuccess = (0, _reduxAct.createAction)('/MOVE_PROPERTY_TO_TOP_SUCCESS');
var movePropertyToTopFail = (0, _reduxAct.createAction)('/MOVE_PROPERTY_TO_TOP_FAIL');
var activateAutoJump = (0, _reduxAct.createAction)('/ACTIVATE_AUTO_JUMP');
var activateAutoJumpSuccess = (0, _reduxAct.createAction)('/ACTIVATE_AUTO_JUMP_SUCCESS');
var activateAutoJumpFail = (0, _reduxAct.createAction)('/ACTIVATE_AUTO_JUMP_FAIL');
var activateTopPromotion = (0, _reduxAct.createAction)('/ACTIVATE_TOP_PROMOTION');
var activateTopPromotionSuccess = (0, _reduxAct.createAction)('/ACTIVATE_TOP_PROMOTION_SUCCESS');
var activateTopPromotionFail = (0, _reduxAct.createAction)('/ACTIVATE_TOP_PROMOTION_FAIL');
var clearUserPropertiesData = (0, _reduxAct.createAction)('/DEACTIVATE_PROPERTIES_DATA');
var updatePropertyData = (0, _reduxAct.createAction)('/UPDATE_PROPERTY');
var updatePropertySuccess = (0, _reduxAct.createAction)('/UPDATE_PROPERTY_SUCCESS');
var updatePropertyFail = (0, _reduxAct.createAction)('/UPDATE_PROPERTY_FAIL');
var setCurrentPaginationStep = (0, _reduxAct.createAction)('/UPDATE_PROPERTY_FAIL');
var clearUpdatedState = (0, _reduxAct.createAction)('/CLEAR_UPDATED_STATE');

var replacePropertyBiId = function replacePropertyBiId() {var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var property = arguments[1];return (
    properties.map(function (prop) {return prop.id === property.id ? Object.assign({}, property) : Object.assign({}, prop);}));};

var updatePropertiesEnabledState = function updatePropertiesEnabledState() {var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];var enabled = arguments[3];return properties.map(function (property) {
    var updatedProperty = Object.assign({}, property);

    if (ids.includes(updatedProperty.id)) {
      fields.forEach(function (field) {
        updatedProperty[field] = enabled;

        if (field === 'is_autojump_enabled') {
          updatedProperty.is_top_promoted = false;
          updatedProperty.is_promoted = false;
        }
      });
    }

    return updatedProperty;
  });};

var decoratePropertyAddress = function decoratePropertyAddress(property) {
  var isFull = !!(0, _get2.default)(property, 'address.en.house_number', false);
  if (isFull) {
    property.address.isFull = isFull;
  }

  if (property.address) {
    delete property.address.place_id;
    delete property.address.tags;
  }
  return property;
};

var initialState = {
  loaded: false,
  promotionUpdated: false,
  isViewsChartOpen: false,
  chartsData: undefined,
  currentPaginationStep: 1 };


var findPropertyById = function findPropertyById(properties, neededId) {return properties.find(function (_ref) {var id = _ref.id;return id === neededId;});};

var fetchLoad = function fetchLoad(_ref2) {var token = _ref2.token,data = _ref2.data,$sort = _ref2.$sort;return (
    (0, _axios2.default)({
      method: 'get',
      url: '/properties/my',
      headers: {
        access_token: token },

      params: Object.assign({},
      data, {
        $sort: $sort }) }).


    then(loadUserPropertiesSuccess, loadUserPropertiesFail));};

var fetchExport = function fetchExport(_ref3) {var token = _ref3.token,data = _ref3.data,$sort = _ref3.$sort;return _axios2.default.
  get('/properties/my_export', {
    headers: {
      access_token: token },

    responseType: 'arraybuffer',
    params: Object.assign({},
    data, {
      $sort: $sort || '-created_at' }) }).


  then(exportUserPropertiesSuccess, exportUserPropertiesFail);};

var fetchLoadPropertyById = function fetchLoadPropertyById(_ref4) {var id = _ref4.id,my = _ref4.my,token = _ref4.token;return (
    _axios2.default.get('/properties/' + id + '?my=' + my, { headers: { access_token: token } }).
    then(loadPropertyByIdSuccess, loadPropertyByIdFail));};

var handleLoad = function handleLoad(state, data) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchLoad, data));};
var handleExport = function handleExport(state, data) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchExport, data));};

var handleLoadPropertyById = function handleLoadPropertyById(state, _ref5) {var id = _ref5.id,my = _ref5.my,token = _ref5.token;return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchLoadPropertyById, { id: id, my: my, token: token })));};

var handleLoadSuccess = function handleLoadSuccess(state, _ref6) {var data = _ref6.data;
  var propertiesIds = [];

  if (data) {
    propertiesIds = data.data.map(function (item) {return item.id;});

    data.data = (data.data || []).
    map(decoratePropertyAddress).
    sort(function (a, b) {return b.is_active - a.is_active;});
  }

  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data,
    meta: data.meta,
    propertiesIds: propertiesIds });

};

var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading user properties for manage');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    propertiesIds: [],
    error: error });

};

var handleExportSuccess = function handleExportSuccess(state, response) {
  var date = (0, _moment2.default)().format('DD_MM_YYYY');
  var fileName = 'onmap_export_' + date;
  var mime = (0, _get2.default)(response, 'headers.content-type', '');

  var file = new File([response.data], fileName, { type: mime });
  (0, _fileSaver.saveAs)(file);

  return Object.assign({},
  state, {
    loading: false,
    loaded: true });

};

var handleExportFail = function handleExportFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading user properties for manage');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error });

};

var handleLoadPropertyByIdSuccess = function handleLoadPropertyByIdSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    editedProperty: decoratePropertyAddress(action.data) });};


var handleLoadPropertyByIdFail = function handleLoadPropertyByIdFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading property by id in manage');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    editedProperty: undefined,
    error: error });

};

var handleEditProperty = function handleEditProperty(state, action) {return Object.assign({},
  state, {
    loaded: true,
    editedProperty: state.data && state.data.data && state.data.data.length ?
    findPropertyById(state.data.data, action) :
    null });};


var fetchPropertyActivity = function fetchPropertyActivity(_ref7) {var ids = _ref7.ids,active = _ref7.active,access_token = _ref7.access_token,isAgent = _ref7.isAgent;return (
    _axios2.default.post('/properties/activate', { ids: ids, active: active }, { headers: { access_token: access_token } }).
    then(function (resp) {return updatePropertyActivitySuccess(Object.assign({}, resp, { isAgent: isAgent }));}, updatePropertyActivityFail));};

var fetchPropertyHighlighting = function fetchPropertyHighlighting(_ref8) {var ids = _ref8.ids,promote = _ref8.promote,access_token = _ref8.access_token;return (
    _axios2.default.post('/properties/promote', { ids: ids, promote: promote }, { headers: { access_token: access_token } }).
    then(updatePropertyHighlightingSuccess, updatePropertyHighlightingFail));};

var fetchMovePropertyToTop = function fetchMovePropertyToTop(_ref9) {var id = _ref9.id,access_token = _ref9.access_token;return (
    _axios2.default.post('/properties/top/' + id, {}, { headers: { access_token: access_token } }).
    then(function () {return movePropertyToTopSuccess(id);}, movePropertyToTopFail));};

var fetchSecondJumpToTop = function fetchSecondJumpToTop(_ref10) {var id = _ref10.id,access_token = _ref10.access_token;return (
    _axios2.default.put('/properties/' + id + '/shared', {}, { headers: { access_token: access_token } }).
    then(function () {return secondJumpToTopSuccess(id);}, secondJumpToTopFail));};

var fetchActivateAutoJump = function fetchActivateAutoJump(_ref11) {var data = _ref11.data,token = _ref11.token;return (
    _axios2.default.post('/properties/autojump', data, { headers: { access_token: token } }).
    then(activateAutoJumpSuccess, activateAutoJumpFail));};

var fetchActivateTopPromotion = function fetchActivateTopPromotion(_ref12) {var data = _ref12.data,token = _ref12.token;return (
    _axios2.default.post('/properties/top_promote', data, { headers: { access_token: token } }).
    then(activateTopPromotionSuccess, activateTopPromotionFail));};

var _getMetaInfo = function _getMetaInfo(state, response) {var
  data = response.data;
  if (data.isForeign) {
    return {
      user_properties: (0, _get2.default)(state, 'data.meta.user_properties'),
      user_foreign_properties: data };

  }
  return {
    user_properties: data,
    user_foreign_properties: (0, _get2.default)(state, 'data.meta.user_foreign_properties') };

};

var movePropertyToTopHandler = function movePropertyToTopHandler(state, params) {return (
    (0, _reduxLoop.loop)(Object.assign({},
    state, {
      jumping: true,
      jumped: false,
      jumpFailed: null,
      jumpedProperty: null }),
    promise(fetchMovePropertyToTop, params)));};

var handleSecondJumpToTop = function handleSecondJumpToTop(state, params) {return (0, _reduxLoop.loop)(Object.assign({}, state), promise(fetchSecondJumpToTop, params));};


var activateAutoJumpHandler = function activateAutoJumpHandler(state, params) {return (
    (0, _reduxLoop.loop)(Object.assign({},
    state, {
      autoJumpActivating: true,
      autoJumpActivated: false,
      autoJumpActivateFailed: null,
      autoJumpActivatedProperty: null,
      promotionUpdated: false,
      promotionFailed: false }),
    promise(fetchActivateAutoJump, params)));};

var activateTopPromotionHandler = function activateTopPromotionHandler(state, params) {return (
    (0, _reduxLoop.loop)(Object.assign({},
    state, {
      topPromotionActivating: true,
      topPromotionActivated: false,
      promotionUpdated: false,
      promotionFailed: false }),
    promise(fetchActivateTopPromotion, params)));};

var updatePropertyActivityHandler = function updatePropertyActivityHandler(state, params) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { updating: true, updated: false, error: null }), promise(fetchPropertyActivity, params)));};

var updatePropertyHighlightingHandler = function updatePropertyHighlightingHandler(state, params) {return (
    (0, _reduxLoop.loop)(Object.assign({},
    state, {
      highlighting: true,
      highlighted: false,
      promotionUpdated: false,
      promotionFailed: false,
      error: null }),

    promise(fetchPropertyHighlighting, params)));};

var handleUpdatePropertyActivitySuccess = function handleUpdatePropertyActivitySuccess(state, response) {var
  config = response.config,isAgent = response.isAgent;var _JSON$parse =
  JSON.parse(config.data),ids = _JSON$parse.ids,active = _JSON$parse.active;

  var properties = (0, _get2.default)(state, 'data.data');

  var propertiesAfterDeactivate = isAgent ?
  updatePropertiesEnabledState(properties, ids, ['is_active', 'is_autojump_enabled', 'is_promoted', 'is_top_promoted'], active) :
  updatePropertiesEnabledState(properties, ids, ['is_active'], active);

  var newUserProps = active ?
  updatePropertiesEnabledState(properties, ids, ['is_active'], active) :
  propertiesAfterDeactivate;

  var metaInfo = _getMetaInfo(state, response);

  return Object.assign({},
  state, {
    data: {
      data: newUserProps,
      meta: metaInfo },

    updating: false,
    updated: true });

};

var handleUpdatePropertyActivityFail = function handleUpdatePropertyActivityFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while updating property activity');

  return Object.assign({},
  state, {
    updating: false,
    updated: false,
    error: error });

};

var handleUpdatePropertyHighlightingSuccess = function handleUpdatePropertyHighlightingSuccess(state, response) {var
  config = response.config;var _JSON$parse2 =
  JSON.parse(config.data),ids = _JSON$parse2.ids,promote = _JSON$parse2.promote;

  var newUserProps = state.data.data.map(function (property) {
    if (ids.includes(property.id)) {
      property.is_promoted = promote;
      property.is_top_promoted = false;
      property.is_autojump_enabled = false;
    }
    return property;
  });

  var metaInfo = _getMetaInfo(state, response);

  return Object.assign({},
  state, {
    data: {
      data: newUserProps,
      meta: metaInfo },

    highlighting: false,
    highlighted: true,
    promotionUpdated: true });

};

var handleActivateTopPromotionSuccess = function handleActivateTopPromotionSuccess(state, response) {var
  config = response.config;var _JSON$parse3 =
  JSON.parse(config.data),ids = _JSON$parse3.ids,enable = _JSON$parse3.enable;

  var newUserProps = state.data.data.map(function (property) {
    if (ids.includes(property.id)) {
      property.is_top_promoted = enable;
      property.is_promoted = false;
      property.is_autojump_enabled = false;
    }
    return property;
  });

  var metaInfo = _getMetaInfo(state, response);

  return Object.assign({},
  state, {
    data: {
      data: newUserProps,
      meta: metaInfo },

    topPromotionActivating: false,
    topPromotionActivated: true,
    promotionUpdated: true });

};

var handleActivateTopPromotionFail = function handleActivateTopPromotionFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while updating property top promotion');

  return Object.assign({},
  state, {
    error: error,
    topPromotionActivating: false,
    topPromotionActivated: true,
    promotionFailed: true });

};

var handleUpdatePropertyHighlightingFail = function handleUpdatePropertyHighlightingFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while updating property highlight');

  return Object.assign({},
  state, {
    highlighting: false,
    highlighted: false,
    promotionFailed: true,
    error: error });

};

var handleMovePropertyToTopSuccess = function handleMovePropertyToTopSuccess(state, id) {
  var currentDate = (0, _moment2.default)().toISOString();
  var data = [].concat(state.data.data);
  var meta = Object.assign({}, state.data.meta);
  var jumpedProperty = {};

  data.forEach(function (item) {
    if (item.id === id) {
      item.move_to_top = false;
      item.manual_jump_date = currentDate;
      jumpedProperty = item;
    }
  });

  return Object.assign({},
  state, {
    data: {
      data: data,
      meta: meta },

    jumpedProperty: jumpedProperty,
    jumping: false,
    jumped: true });

};

var handleMovePropertyToTopFail = function handleMovePropertyToTopFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while moving property to top');

  return Object.assign({},
  state, {
    jumping: false,
    jumped: false,
    jumpFailed: error });

};

var handleSecondJumpToTopSuccess = function handleSecondJumpToTopSuccess(state, id) {
  var data = [].concat(state.data.data);
  var meta = Object.assign({}, state.data.meta);
  var jumpedProperty = {};

  data.forEach(function (item) {
    if (item.id === id) {
      item.shared_today = true;
      jumpedProperty = item;
    }
  });

  return Object.assign({},
  state, {
    data: {
      data: data,
      meta: meta },

    jumpedProperty: jumpedProperty });

};

var handleSecondJumpToTopFail = function handleSecondJumpToTopFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while second jump to top');

  return Object.assign({},
  state, {
    error: error });

};

var handleActivateAutoJumpSuccess = function handleActivateAutoJumpSuccess(state, response) {var
  config = response.config;var _JSON$parse4 =
  JSON.parse(config.data),ids = _JSON$parse4.ids,enable = _JSON$parse4.enable;

  var properties = (0, _get2.default)(state, 'data.data');
  var newUserProps = updatePropertiesEnabledState(properties, ids, ['is_autojump_enabled'], enable);

  var metaInfo = _getMetaInfo(state, response);

  return Object.assign({},
  state, {
    data: {
      data: newUserProps,
      meta: metaInfo },

    autoJumpActivating: false,
    autoJumpActivated: true,
    promotionUpdated: true });

};

var handleActivateAutoJumpFail = function handleActivateAutoJumpFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while actvationg autojump');

  return Object.assign({},
  state, {
    autoJumpActivating: false,
    autoJumpActivated: false,
    autoJumpActivateFailed: error,
    promotionFailed: true });

};

var clearUserPropertiesDataHandler = function clearUserPropertiesDataHandler(state) {return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    updating: false,
    updated: false,
    editedProperty: undefined,
    data: null });};


var handleClearUpdatedState = function handleClearUpdatedState(state) {return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    updating: false,
    updated: false,
    editedProperty: undefined });};


var fetchUpdateProperty = function fetchUpdateProperty(_ref13) {var id = _ref13.id,propertyData = _ref13.propertyData,access_token = _ref13.access_token;return (
    _axios2.default.put('/properties/' + id, propertyData, { headers: { access_token: access_token } }).
    then(updatePropertySuccess, updatePropertyFail));};

var updatePropertyHandler = function updatePropertyHandler(state, value) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { updating: true, updated: false, error: null }), promise(fetchUpdateProperty, value)));};

var handleUpdatePropertySuccess = function handleUpdatePropertySuccess(state, action) {return Object.assign({},
  state, {
    updating: false,
    updated: true,
    data: Object.assign({},
    state.data, {
      data: replacePropertyBiId(state.data.data, action.data) }),

    editedProperty: undefined });};


var handleUpdatePropertyFail = function handleUpdatePropertyFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while updating property data');

  return Object.assign({},
  state, {
    updating: false,
    updated: false,
    data: state.data,
    error: error });

};

var fetchUpdatePropertiesContacts = function fetchUpdatePropertiesContacts(_ref14) {var data = _ref14.data,access_token = _ref14.access_token;return (
    _axios2.default.post('/properties/update-contacts',
    data,
    { headers: { access_token: access_token } }).
    then(updatePropertiesContactsSuccess, updatePropertiesContactsFail));};

var handleUpdatePropertiesContacts = function handleUpdatePropertiesContacts(state, value) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state), promise(fetchUpdatePropertiesContacts, value)));};

var handleUpdatePropertiesContactsSuccess = function handleUpdatePropertiesContactsSuccess(state, response) {
  var updatedPropertiesMap = response.data.reduce(function (acc, curr) {
    acc[curr.id] = curr;
    return acc;
  }, {});

  var updatedDataArray = state.data.data.map(function (property) {
    var updatedProperty = updatedPropertiesMap[property.id];
    return updatedProperty || property;
  });

  var data = Object.assign({},
  state.data, {
    data: updatedDataArray });


  return Object.assign({}, state, { data: data });
};

var handleUpdatePropertiesContactsFail = function handleUpdatePropertiesContactsFail(state, response) {
  var error = (0, _formatApiError2.default)(
  response,
  'Error while updating properties contacts in manage');


  return Object.assign({},
  state, {
    error: error });

};

var handleSetCurrentPaginationStep = function handleSetCurrentPaginationStep(state, action) {return Object.assign({},
  state, {
    currentPaginationStep: action });};


var fetchLoadProjectById = function fetchLoadProjectById(_ref15) {var id = _ref15.id;return (
    _axios2.default.get('/projects/' + id).then(loadProjectByIdSuccess, loadProjectByIdFail));};

var handleLoadProjectById = function handleLoadProjectById(state, _ref16) {var id = _ref16.id;return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchLoadProjectById, { id: id })));};

var handleLoadProjectByIdSuccess = function handleLoadProjectByIdSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    editedProject: action.data });};


var handleLoadProjectByIdFail = function handleLoadProjectByIdFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading property by id in manage');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    editedProject: undefined,
    error: error });

};

var manageProperties = (0, _reduxAct.createReducer)(function (on) {
  on(loadUserProperties, handleLoad);
  on(loadUserPropertiesSuccess, handleLoadSuccess);
  on(loadUserPropertiesFail, handleLoadFail);
  on(exportUserProperties, handleExport);
  on(exportUserPropertiesSuccess, handleExportSuccess);
  on(exportUserPropertiesFail, handleExportFail);
  on(loadPropertyById, handleLoadPropertyById);
  on(loadPropertyByIdSuccess, handleLoadPropertyByIdSuccess);
  on(loadPropertyByIdFail, handleLoadPropertyByIdFail);

  on(loadProjectById, handleLoadProjectById);
  on(loadProjectByIdSuccess, handleLoadProjectByIdSuccess);
  on(loadProjectByIdFail, handleLoadProjectByIdFail);

  on(updatePropertiesContacts, handleUpdatePropertiesContacts);
  on(updatePropertiesContactsSuccess, handleUpdatePropertiesContactsSuccess);
  on(updatePropertiesContactsFail, handleUpdatePropertiesContactsFail);

  on(editProperty, handleEditProperty);
  on(updatePropertyActivity, updatePropertyActivityHandler);
  on(updatePropertyActivitySuccess, handleUpdatePropertyActivitySuccess);
  on(updatePropertyActivityFail, handleUpdatePropertyActivityFail);
  on(updatePropertyHighlighting, updatePropertyHighlightingHandler);
  on(updatePropertyHighlightingSuccess, handleUpdatePropertyHighlightingSuccess);
  on(updatePropertyHighlightingFail, handleUpdatePropertyHighlightingFail);
  on(movePropertyToTop, movePropertyToTopHandler);
  on(movePropertyToTopSuccess, handleMovePropertyToTopSuccess);
  on(movePropertyToTopFail, handleMovePropertyToTopFail);
  on(secondJumpToTop, handleSecondJumpToTop);
  on(secondJumpToTopSuccess, handleSecondJumpToTopSuccess);
  on(secondJumpToTopFail, handleSecondJumpToTopFail);
  on(activateAutoJump, activateAutoJumpHandler);
  on(activateAutoJumpSuccess, handleActivateAutoJumpSuccess);
  on(activateAutoJumpFail, handleActivateAutoJumpFail);
  on(activateTopPromotion, activateTopPromotionHandler);
  on(activateTopPromotionSuccess, handleActivateTopPromotionSuccess);
  on(activateTopPromotionFail, handleActivateTopPromotionFail);
  on(clearUserPropertiesData, clearUserPropertiesDataHandler);
  on(updatePropertyData, updatePropertyHandler);
  on(updatePropertySuccess, handleUpdatePropertySuccess);
  on(updatePropertyFail, handleUpdatePropertyFail);
  on(setCurrentPaginationStep, handleSetCurrentPaginationStep);
  on(clearUpdatedState, handleClearUpdatedState);
}, initialState);exports.


loadUserProperties = loadUserProperties;exports.
exportUserProperties = exportUserProperties;exports.
loadPropertyById = loadPropertyById;exports.
loadProjectById = loadProjectById;exports.
editProperty = editProperty;exports.
movePropertyToTop = movePropertyToTop;exports.
secondJumpToTop = secondJumpToTop;exports.
activateAutoJump = activateAutoJump;exports.
activateTopPromotion = activateTopPromotion;exports.
clearUserPropertiesData = clearUserPropertiesData;exports.
updatePropertyActivity = updatePropertyActivity;exports.
updatePropertyHighlighting = updatePropertyHighlighting;exports.
updatePropertyData = updatePropertyData;exports.
setCurrentPaginationStep = setCurrentPaginationStep;exports.
clearUpdatedState = clearUpdatedState;exports.
updatePropertiesContacts = updatePropertiesContacts;exports.default =


manageProperties;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/manageProperties.js
// module id = 101
// module chunks = 0